/* eslint-disable react-hooks/rules-of-hooks */
import { useBasicDetails } from '../../store/storeApi';
import { useEffect } from 'react';
import { SessionStore } from '../../constants/sessionStore';

/**
 * update template store from session storage,
 * stop update if session and store have same values
 */
export const updateTemplateStoreFromSession = (): void => {
  const { template, updateTemplate } = useBasicDetails();

  useEffect(() => {
    const initialStoreTemplateValue = JSON.stringify(template);
    const sessionStorageTemplateValue = sessionStorage.getItem(SessionStore.template);
    if (sessionStorageTemplateValue !== null && initialStoreTemplateValue !== sessionStorageTemplateValue) {
      const updatedTemplate = JSON.parse(sessionStorageTemplateValue);
      updateTemplate(updatedTemplate);
    }
  }, [template, updateTemplate]);
};
